export const appBrandConfig = {
  name: 'IAM Platform',
  shortName: 'IAM',
  description: 'Centralized Platform System & IAM Service',
  version: '1.0.0',
  copyright: '2026',
} as const;
